<style lang="less" scoped="">
  #header {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 200;
  }
  .layout-logo {
    margin-left: 20px;
    color: #fff;
    font-size: 20px;
    position: relative;
  }

  .header-user {
    position: absolute;
    margin-right: 20px;
    top: 0px;
    right: 0px;
  }
  .header-msg {
    position: absolute;
    margin-right: 200px;
    top: 0px;
    right: 0px;
  }
  .layout-nav {
    position: absolute;
    width: 420px;
    margin-right: 400px;
    top: 15px;
    right: 0px;
  }
  .layout-announcement {
    position: absolute;
    width: 600px;
    margin-right: 850px;
    top: 15px;
    right: 0px;
  }
</style>
<template>
  <div id="header">
    <Menu mode="horizontal" theme="dark" active-name="1">
      <div class="layout-logo">
        <h3>管理系统</h3>
      </div>
      <div class="header-msg">
        <Message></Message>
      </div>
      <div class="layout-announcement">
        <Announcement/>
      </div>
      <div class="header-user">
        <Dropdown v-if="isLogin" @on-click="userMenuClick" placement="bottom-end">
          <a href="javascript:void(0)">
            {{ mobile }}
            <Icon type="arrow-down-b"></Icon>
          </a>
          <Dropdown-menu slot="list">
            <Dropdown-item name="logout">退出登录</Dropdown-item>
          </Dropdown-menu>
        </Dropdown>
        <router-link v-if="!isLogin" :to="{path: '/login', query: {backUrl: this.$route.fullPath}}">登录</router-link>
      </div>
    </Menu>
  </div>
</template>
<script>
  import Message from '../message/message.vue'
  import Announcement from "./Announcement.vue";
  export default {
    components: {
      Announcement,
      Message
    },
    data () {
      return {
        isLogin: false,
        mobile: ''
      }
    },
    methods: {
      userMenuClick (name) {
        if (name === 'logout') {
          this.$store.remove('token')
          this.$store.remove('mobile')
          this.$store.remove('password')

          this.$router.push({path: '/login', query: {backUrl: this.$route.path}})
        }
      }
    },
    created () {
      this.mobile = this.$store.get('mobile')
      this.isLogin = this.mobile !== undefined && this.mobile !== ''
    }
  }
</script>



// WEBPACK FOOTER //
// CommonHeader.vue?64115530